import styled from 'styled-components';
import { Input as SemanticInput } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const ContainerInput = styled.div`
  display: inline-flex;
  justify-content: flex-end;
`;

export const ContainerText = styled.div`
  flex-grow: 1;
`;

export const Input = styled(SemanticInput)`
  width: 90%;
`;

export const ModalContent = styled.div`
  &&& {
    display: flex;
    align-items: center;
  }
`;

export const ContainerPayment = styled.div`
  width: 700px;
`;

export const ContainerErrorMessage = styled.div`
  display: block;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)`
  float: right;
`;
